import { apiFetch } from './api';

export const INSTAGRAM_START_PATH = '/api/instagram/start';

export interface InstagramAccountWebhook {
  status: string;
  fields: string[];
  subscribed_at: number | null;
}

export interface InstagramAccount {
  id: string;
  ig_user_id: string;
  username: string;
  name: string | null;
  account_type: string | null;
  profile_picture_url: string | null;
  followers_count: number | null;
  status: string;
  webhook: InstagramAccountWebhook;
  connected_at: number | null;
  created_at: number;
  updated_at: number;
}

export interface InstagramAccountsResponse {
  accounts: InstagramAccount[];
}

export function listInstagramAccountsRequest(): Promise<InstagramAccountsResponse> {
  return apiFetch<InstagramAccountsResponse>('/api/instagram/accounts');
}
